import { useMutation, useQueryClient } from "@tanstack/react-query";
import { importaTargetareContacte } from "@/api/endpoints/targetareContacte";
import { queryKeys } from "@/lib/queryClient";

export function useImportaTargetareContacte() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: importaTargetareContacte,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.targetare.all });
    },
  });
}
